/**
 * @generated SignedSource<<ce0ae153f9d23006b7df51b13f002209>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PanelRecruitFilterEnum = "MATCHED_PANEL" | "RECRUITED_PANEL" | "%future added value";
export type ScreenersRecruitStatusChoices = "F" | "NS" | "P" | "S" | "%future added value";
export type RecruitYourPanel_Query$variables = {
  count: number;
  cursor?: string | null;
  panelFilters?: any | null;
  panelRecruitFilter?: PanelRecruitFilterEnum | null;
  panelSettings?: string | null;
  recruitId: string;
  searchTerm?: string | null;
  studyId: string;
};
export type RecruitYourPanel_Query$data = {
  readonly viewer: {
    readonly recruit: {
      readonly status: ScreenersRecruitStatusChoices;
      readonly " $fragmentSpreads": FragmentRefs<"RecruitMatch_recruit">;
    } | null;
    readonly study: {
      readonly " $fragmentSpreads": FragmentRefs<"RecruitMatch_study">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"RecruitMatch_viewer">;
  };
};
export type RecruitYourPanel_Query = {
  response: RecruitYourPanel_Query$data;
  variables: RecruitYourPanel_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "panelFilters"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "panelRecruitFilter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "panelSettings"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recruitId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchTerm"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "studyId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "studyId",
    "variableName": "studyId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "recruitId",
    "variableName": "recruitId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "kind": "Variable",
  "name": "panelFilters",
  "variableName": "panelFilters"
},
v5 = {
  "kind": "Variable",
  "name": "panelRecruitFilter",
  "variableName": "panelRecruitFilter"
},
v6 = {
  "kind": "Variable",
  "name": "panelSettings",
  "variableName": "panelSettings"
},
v7 = {
  "kind": "Variable",
  "name": "searchTerm",
  "variableName": "searchTerm"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enablePanelExport",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v14 = [
  (v8/*: any*/),
  (v13/*: any*/)
],
v15 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CharacteristicNode",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v8/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "importKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shortName",
        "storageKey": null
      },
      (v13/*: any*/),
      (v11/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "CharacteristicAnswerNode",
        "kind": "LinkedField",
        "name": "answers",
        "plural": true,
        "selections": (v14/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CharacteristicRowNode",
        "kind": "LinkedField",
        "name": "rows",
        "plural": true,
        "selections": (v14/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v18 = [
  (v17/*: any*/)
],
v19 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v20 = [
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecruitYourPanel_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RecruitMatch_study"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "RecruitNode",
            "kind": "LinkedField",
            "name": "recruit",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "count",
                    "variableName": "count"
                  },
                  {
                    "kind": "Variable",
                    "name": "cursor",
                    "variableName": "cursor"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "RecruitMatch_recruit"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RecruitMatch_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecruitYourPanel_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "panelFilters",
                "storageKey": null
              },
              (v3/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TenantNode",
                "kind": "LinkedField",
                "name": "tenant",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CharacteristicNodeConnection",
                    "kind": "LinkedField",
                    "name": "characteristics",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CharacteristicNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": (v15/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TenantGlobalCharacteristicsConnection",
                    "kind": "LinkedField",
                    "name": "globalCharacteristics",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TenantGlobalCharacteristicsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": (v15/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vpmAccountId",
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "RecruitNode",
            "kind": "LinkedField",
            "name": "recruit",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dbId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ExportNode",
                "kind": "LinkedField",
                "name": "export",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "countCompleted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "countTotal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sentOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sentTo",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserNode",
                    "kind": "LinkedField",
                    "name": "to",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "matched",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "panelRecruitFilter",
                    "value": "MATCHED_PANEL"
                  }
                ],
                "concreteType": "PanelistConnection",
                "kind": "LinkedField",
                "name": "eligiblePanelists",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": "eligiblePanelists(panelRecruitFilter:\"MATCHED_PANEL\")"
              },
              (v10/*: any*/),
              {
                "alias": "recruited",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "panelRecruitFilter",
                    "value": "RECRUITED_PANEL"
                  }
                ],
                "concreteType": "PanelistConnection",
                "kind": "LinkedField",
                "name": "eligiblePanelists",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": "eligiblePanelists(panelRecruitFilter:\"RECRUITED_PANEL\")"
              },
              {
                "alias": "table",
                "args": (v19/*: any*/),
                "concreteType": "PanelistConnection",
                "kind": "LinkedField",
                "name": "eligiblePanelists",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PanelistEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PanelistNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "completedStudiesCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PersonNode",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "firstName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastName",
                                "storageKey": null
                              },
                              (v16/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "phoneNumber",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PanelistNode",
                                "kind": "LinkedField",
                                "name": "panelist",
                                "plural": false,
                                "selections": (v20/*: any*/),
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PanelistMembershipNode",
                            "kind": "LinkedField",
                            "name": "panelistMembership",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "latestCompleteScreenerName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "latestCompleteScreenerDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "latestStudyName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "latestStudyDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ParticipantNode",
                                "kind": "LinkedField",
                                "name": "latestRatedParticipant",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "rating",
                                    "storageKey": null
                                  },
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "joined",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "recruitedToStudy",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "recruitStatus",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharacteristicResponseNodeConnection",
                            "kind": "LinkedField",
                            "name": "responses",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CharacteristicResponseNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CharacteristicResponseNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CharacteristicNode",
                                        "kind": "LinkedField",
                                        "name": "characteristic",
                                        "plural": false,
                                        "selections": (v20/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CharacteristicAnswerNode",
                                        "kind": "LinkedField",
                                        "name": "answer",
                                        "plural": false,
                                        "selections": (v20/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CharacteristicRowNode",
                                        "kind": "LinkedField",
                                        "name": "row",
                                        "plural": false,
                                        "selections": (v14/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "textValue",
                                        "storageKey": null
                                      },
                                      (v8/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "table",
                "args": (v19/*: any*/),
                "filters": [
                  "panelSettings",
                  "panelFilters",
                  "panelRecruitFilter",
                  "searchTerm"
                ],
                "handle": "connection",
                "key": "RecruitMatch_table",
                "kind": "LinkedHandle",
                "name": "eligiblePanelists"
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isStaff",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TenantNode",
                    "kind": "LinkedField",
                    "name": "tenant",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "55086f535e43bef35527231eca973214",
    "id": null,
    "metadata": {},
    "name": "RecruitYourPanel_Query",
    "operationKind": "query",
    "text": "query RecruitYourPanel_Query(\n  $count: Int!\n  $cursor: String\n  $panelFilters: GenericScalar\n  $panelRecruitFilter: PanelRecruitFilterEnum\n  $panelSettings: String\n  $recruitId: String!\n  $searchTerm: String\n  $studyId: String!\n) {\n  viewer {\n    study(studyId: $studyId) {\n      ...RecruitMatch_study\n      id\n    }\n    recruit(recruitId: $recruitId) {\n      status\n      ...RecruitMatch_recruit_46cIZL\n      id\n    }\n    ...RecruitMatch_viewer\n  }\n}\n\nfragment ExportButton_export on ExportNode {\n  id\n  countCompleted\n  countTotal\n  sentOn\n  sentTo\n  status\n  to {\n    email\n    id\n  }\n}\n\nfragment RecruitMatch_recruit_46cIZL on RecruitNode {\n  id\n  dbId\n  export {\n    ...ExportButton_export\n    id\n  }\n  matched: eligiblePanelists(panelRecruitFilter: MATCHED_PANEL) {\n    totalCount\n  }\n  name\n  recruited: eligiblePanelists(panelRecruitFilter: RECRUITED_PANEL) {\n    totalCount\n  }\n  status\n  table: eligiblePanelists(first: $count, after: $cursor, panelSettings: $panelSettings, panelRecruitFilter: $panelRecruitFilter, panelFilters: $panelFilters, searchTerm: $searchTerm) {\n    totalCount\n    edges {\n      node {\n        id\n        dId\n        completedStudiesCount\n        person {\n          firstName\n          lastName\n          email\n          phoneNumber\n          panelist {\n            id\n          }\n          id\n        }\n        panelistMembership {\n          latestCompleteScreenerName\n          latestCompleteScreenerDate\n          latestStudyName\n          latestStudyDate\n          latestRatedParticipant {\n            rating\n            id\n          }\n          id\n        }\n        joined\n        recruitedToStudy\n        recruitStatus\n        responses {\n          edges {\n            node {\n              characteristic {\n                id\n              }\n              answer {\n                id\n              }\n              row {\n                id\n                text\n              }\n              textValue\n              id\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  type\n}\n\nfragment RecruitMatch_study on StudyNode {\n  id\n  dId\n  name\n  panelFilters\n  status\n  type\n  tenant {\n    enablePanelExport\n    name\n    characteristics {\n      edges {\n        node {\n          id\n          importKey\n          shortName\n          text\n          type\n          answers {\n            id\n            text\n          }\n          rows {\n            id\n            text\n          }\n        }\n      }\n    }\n    globalCharacteristics {\n      edges {\n        node {\n          id\n          importKey\n          shortName\n          text\n          type\n          answers {\n            id\n            text\n          }\n          rows {\n            id\n            text\n          }\n        }\n      }\n    }\n    dId\n    vpmAccountId\n    id\n  }\n}\n\nfragment RecruitMatch_viewer on Viewer {\n  user {\n    isStaff\n    profile {\n      tenant {\n        enablePanelExport\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a8da62497f1496e52bc5188d4b133c9e";

export default node;
